import { Component, ChangeDetectionStrategy } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CamelCasePipe } from '../../pipes/camel-case.pipe';

@Component({
    selector: 'app-resumo-pedido',
    templateUrl: './resumo-pedido.component.html',
    styleUrls: ['./resumo-pedido.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BreadcrumbComponent, FooterComponent, CamelCasePipe]
})
export class ResumoPedidoComponent {

  private readonly idImportacao: any;
  public resumoPedido: any = "Sucesso";
  
  constructor() { 
    this.idImportacao = localStorage.idImportacao;
  }
}
